<template>
  <div class="Index">
    <header class="header">
      <div class="logo ml-default">
        <img :src="siteLogoPath" height="42" />
      </div>
    </header>
    <section>
      <el-card class="box-card mt-default mh-default">
        <div slot="header" class="clearfix">
          <i class="fas fa-truck" />
          <span>출고정보</span>
        </div>
        <div>
          <table>
            <col width="100"/>
            <col/>
            <tr>
              <th>출고처</th>
              <td>{{good.customer_name}}</td>
            </tr>
            <tr>
              <th>출고일</th>
              <td>{{good.delivery_date}}</td>
            </tr>
            <tr>
              <th>현 장</th>
              <td>{{good.field}}</td>
            </tr>
          </table>
        </div>
      </el-card>
      <el-card class="box-card mt-default mh-default">
        <div slot="header" class="clearfix">
          <i class="fas fa-box" />
          <span>제품정보</span>
        </div>
        <div>
          <table>
            <col width="100"/>
            <col/>
            <tr>
              <th>품번</th>
              <td>{{code}}</td>
            </tr>
            <tr>
              <th>품목</th>
              <td>{{good.product_name}}</td>
            </tr>
            <tr>
              <th>규 격</th>
              <td>{{good.size}}</td>
            </tr>
            <tr>
              <th>치 수</th>
              <td>
                도어치수: {{doorSize | number}},
                레일치수: {{railSize | number}}
              </td>
            </tr>
            <tr>
              <th>사 양</th>
              <td>{{specification}}</td>
            </tr>
          </table>
        </div>
      </el-card>
    </section>
  </div>
</template>
<script>
import { site } from "@/common/mixins/site";

export default {
  name: "Index",
  mixins: [site],
  data() {
    return {
      code: '',
      good: {},
      product: {},
    }
  },
  created() {
    this.code = this.$route.params.code;
  },
  mounted() {
    this.loadData();
  },
  computed: {
    goodSize() {
      if (!this.product || !this.product.categories || !this.good || !this.good.size) {
        return null;
      }
      return this.util.getGoodSize(this.good.size, this.product);
    },
    doorSize() {
      let good_size = this.goodSize;
      if (!good_size) { return ""; }      
      return good_size.door_size;
    },
    railSize() {
      let good_size = this.goodSize;
      if (!good_size) { return ""; }
      return good_size.rail_size;
    },
    specification() {
      if (!this.good || !this.good.details) { return ""; }
      let ret = "";
      this.good.details.forEach(d => {
        if (d.specification && d.specification.includes(this.good.seq)) {
          if (ret.length > 0) { ret += ","; }
          ret += d.product_name + ':' + d.per_amount + 'EA';
        }
      });
      return ret;
    },
  },
  methods: {
    loadData() {
      this.api.selectGoodSale(this.code).then(res => {
        if (res.error !== this.system.noError) {
          return;
        }
        this.good = res.data[0];
        this.api.selectProduct(this.good.product_id).then(res2 => {
          if (res2.error !== this.system.noError) {
            return;
          }
          this.product = res2.data;
        });
      });
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

$border: 1px solid #eee;
.Index {
  .header {
    height: 50px;
    display: flex;
    background-color: $color-primary;
    color: white;
  }
  .el-card__header {
    span {
      padding-left: $space-default;
      font-size: 20px;
      font-weight: bold;
    }
  }
  table {
    width: 100%;
    border: $border;
    border-collapse: collapse;
    tr {
      height: 30px;
      th {
        text-align: center;     
        border: $border;
        background-color: $color-primary;
        color: white;
      }
      td {
        border: $border;
        padding-left: 20px;
      }
    }
  }
}

</style>
